export default "__VITE_ASSET__DQinhMNZ__"